import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { toast } from '../hooks/use-toast';
import { useAuth } from '../context/AuthContext';
import Checkout from './Checkout';
import PlanComparison from './PlanComparison';
import FreePlanDialog from './FreePlanDialog';
import { api } from '../api';

const Pricing = () => {
  const [checkoutPlan, setCheckoutPlan] = useState(null);
  const { user, refresh } = useAuth();
  const navigate = useNavigate();

  const [freeOpen, setFreeOpen] = useState(false);
  const continueFree = async () => {
    setFreeOpen(false);
    if (!user) {
      sessionStorage.setItem('tbt_guest_journey_v1', JSON.stringify({ plan: 'free' }));
      navigate('/onboarding');
      return;
    }
    try { await api.chooseFree(); await refresh(); navigate('/dashboard'); }
    catch (err) { toast({ title: 'Could not switch to the Free Plan', description: err.message }); }
  };
  const handleChoose = (key) => {
    if (!user) {
      sessionStorage.setItem('tbt_selected_plan_v1', key);
      toast({ title: 'Create your account first', description: 'Sign up and complete your brain profile — your 7-day free trial starts when you set up autopay.' });
      navigate('/auth/signup');
      return;
    }
    setCheckoutPlan(key);
  };

  return (
    <>
      <section id="pricing" className="py-14 sm:py-20 lg:py-24 bg-[#3D2817] relative">
        <div className="max-w-6xl mx-auto px-4 sm:px-5 lg:px-8">
          <div className="text-center max-w-2xl mx-auto">
            <p className="text-[#F4C430] text-[10px] sm:text-xs tracking-[0.3em] sm:tracking-[0.35em] uppercase">Pricing</p>
            <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl text-[#F5EDE0] leading-tight">
              Simple plans, real value
            </h2>
            <p className="mt-3 sm:mt-4 text-[#D9C9B3] text-base sm:text-lg" data-testid="pricing-sequence">
              Every paid plan starts with a 7-day free trial — no charge for 7 days, then billed monthly. Cancel anytime. Or stay on the Free Plan with 5 puzzles a day.
            </p>
          </div>

          <div className="mt-10 sm:mt-12">
            <PlanComparison onChoose={handleChoose} showFree />
            <div className="mt-5 text-center">
              <button onClick={() => setFreeOpen(true)} data-testid="pricing-stick-free"
                className="text-sm sm:text-base text-[#D9C9B3] underline underline-offset-4 decoration-[#5a3d24] hover:text-[#F4C430] min-h-[44px] px-3">
                No thanks! I will stick to the free plan
              </button>
            </div>
            <p className="mt-3 text-center text-xs text-[#8f7658] sm:hidden">← Swipe to compare Explorer, Challenger &amp; Master →</p>
          </div>

          <div className="mt-6 text-center">
            <Button variant="link" onClick={() => navigate('/terms')} className="text-[#B8A990] hover:text-[#F4C430] text-xs">
              Billing &amp; cancellation terms
            </Button>
          </div>
        </div>
      </section>

      <Checkout
        open={checkoutPlan !== null}
        onClose={() => setCheckoutPlan(null)}
        plan={checkoutPlan}
        onSuccess={() => {
          setCheckoutPlan(null);
          navigate('/dashboard');
        }}
      />
      <FreePlanDialog open={freeOpen} onClose={() => setFreeOpen(false)} onContinueFree={continueFree}
        onExplore={() => { setFreeOpen(false); document.querySelector('#pricing [data-testid=plan-comparison]')?.scrollIntoView({ behavior: 'smooth', block: 'center' }); }} />
    </>
  );
};

export default Pricing;
